export default __webpack_public_path__ + "static/media/calendar.ce82234c.svg";